export enum ProductTypeEnum {
    products = "products",
    accessories = "accessories",
}
